import { create } from 'zustand';

export const useConfirmModalStore = create((set) => ({
  isOpen: false,
  heading: '',
  description: '',
  closeLabel: 'NO',
  okLabel: 'YES',
  onOk: null,
  onClose: null,
  openConfirmModal: ({ heading, description, closeLabel, okLabel, onOk, onClose }) => {
    set({
      isOpen: true,
      heading,
      description,
      closeLabel: closeLabel || 'NO',
      okLabel: okLabel || 'YES',
      onOk,
      onClose,
    });
  },
  closeConfirmModal: () => {
    set({
      isOpen: false,
      heading: '',
      description: '',
      closeLabel: 'NO',
      okLabel: 'YES',
      onOk: null,
      onClose: null,
    });
  },
}));
